import { configureStore } from '@reduxjs/toolkit';
import productsReducer from "./slices/products";
import settingsReducer from "./slices/settings";
import userReducer from "./slices/user";
import categoryReducer from "./slices/category";
import subCategoryReducer from './slices/subcategory';
import contactReducer from './slices/contactinformation'
import appCategoryReducer from './slices/appliance_category'
import appBrandReducer from './slices/appliance_brand'
import appProductReducer from './slices/appliance_product'

export const store = configureStore({
  reducer: {
     products: productsReducer,
     user: userReducer,
     settings: settingsReducer,
     category: categoryReducer,
     subcategory: subCategoryReducer,
     contact: contactReducer,
     appCategory: appCategoryReducer,
     appBrand: appBrandReducer,
     appProduct: appProductReducer,
  },
});
